import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { ButtonBoxLaunch, Heading } from '@warrenbrasil/nebraska-web';
import { RequestBrokerModal } from './components';

import { TradeButton } from '@/modules/trade/services/buttons';
import { TradeHomeBrokerStatus } from '@/modules/trade/services/account';

interface Emits {
  (event: 'open-home-broker'): void;
  (event: 'open-copytrade'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  props: {
    serviceButtons: null
  },
  emits: ["open-home-broker", "open-copytrade"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'open-home-broker'): void;
  (event: 'open-copytrade'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  serviceButtons: TradeButton[];
};





const router = useRouter();

const showHomeBrokerModal = ref(false);
const homeBrokerStatus = ref('');

const isButtonVisible = (button: TradeButton) => {
  if (button.name === 'marginAllocation') {
    return true;
  }
  return button.enabled;
};

const hasSomeButtonToShow = computed(() =>
  props.serviceButtons?.some((button: TradeButton) => button.enabled)
);

function getChipCustomStyle(chipStyle: string | undefined) {
  if (!chipStyle) return;
  return `services-section__chip--${chipStyle}`;
}

function handleClick(button: TradeButton) {
  switch (button.name) {
    case 'securitiesLendingOverview':
      router.push({ name: button.name, query: { group: 'btcPosition' } });
      break;

    case 'homeBroker':
      handleHomeBrokerClick(button.status as string);
      break;

    case 'copytrade':
      handleCopytradeClick();
      break;

    default:
      router.push({ name: button.name });
      break;
  }
}

function handleHomeBrokerClick(status: string) {
  if (status === TradeHomeBrokerStatus.Enabled) {
    emits('open-home-broker');
    return;
  }

  showHomeBrokerModal.value = true;
  homeBrokerStatus.value = status;
}

function handleCopytradeClick() {
  emits('open-copytrade');
}

async function updateHomeBrokerStatus() {
  showHomeBrokerModal.value = false;
}

return { __sfc: true,props, emits, router, showHomeBrokerModal, homeBrokerStatus, isButtonVisible, hasSomeButtonToShow, getChipCustomStyle, handleClick, handleHomeBrokerClick, handleCopytradeClick, updateHomeBrokerStatus, ButtonBoxLaunch, Heading, RequestBrokerModal }
}

})